import { IoIosAdd } from 'react-icons/io';

import styled from 'styled-components';

export const Header: any = styled.div`
  display: flex;
  align-items: center;
  padding: 0 32px;
  height: 80px;
  box-shadow: 0 2px 8px 0 ${({ theme }) => theme.citiesSearch.shadow};
`;

Header.Search = styled.input`
  width: 100%;
  border: none;
  font-weight: 600;
  font-size: 16px;

  &::placeholder {
    color: ${({ theme }) => theme.citiesSearch.searchPlaceholderColor};
  }
`;

Header.CloseIcon = styled(IoIosAdd)`
  margin-left: auto;
  font-size: 25px;
  transform: rotate(45deg);
`;

export const Result: any = styled.ol`
  overflow-y: auto;
  height: 100%;
`;

Result.NotFound = styled.div`
  padding: 32px;
  text-align: center;

  & > h2 {
    font-size: 32px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    margin-bottom: 16px;
    letter-spacing: normal;
    text-align: center;
    color: ${({ theme }) => theme.notFound.header};
  }

  & > span {
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: ${({ theme }) => theme.notFound.text};
  }
`;

Result.Item = styled.li`
  padding: 32px;
  border-bottom: 1px solid ${({ theme }) => theme.citiesSearch.resultItemColor};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.citiesSearch.optionsHover};
  }

  & > span {
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

Result.Loading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const RecentSearches = styled.span`
  width: 100%;
  padding: 16px 32px;
  font-size: 12px;
  color: ${({ theme }) => theme.citiesSearch.recentColor};
  background-color: ${({ theme }) => theme.citiesSearch.recentBackground};
`;
